import { Controller } from "@hotwired/stimulus"
import StimulusReflex from 'stimulus_reflex';
export default class extends Controller {
  
  connect() {
       StimulusReflex.register(this);
       
       this.refreshTimer = setInterval(() => {
        this.update_timer()
       }, 1000)
/*
       this.refreshTimer2 = setInterval(() => {
         this.stimulate();
       }, 5000)

*/
   
  }
  
  disconnect() {
	   clearInterval(this.refreshTimer);
  }
  
  startStopTimer() {
	  Rails.ajax({
	      type: 'GET',
	      url: "/projects/start_stop_timer/"+ this.data.get("taskid"),
	      dataType: 'json',
	      success: (data) => {
	        //this.loadingProjectSelectorTarget.style.display = "none";
	        //this.projectSelectorTarget.innerHTML = data.projectSelector
	        document.getElementById.innerHTML = data.task;
	   	    //this.projectSelectorTarget.style.display = "block";
	      }
	    });
  }
  update_timer() {
	  
	this.start_time = this.data.get("starttime");
    if (this.start_time == 0) {
       this.current_time_running  = "00:00:00";
    }
   else {
    this.start_time2 = new Date(0);
    this.start_time2.setUTCSeconds(this.start_time);

    this.now = new Date();
    var difference_in_seconds = Math.abs(this.start_time2 - this.now) / 1000;

	var hours =  Math.floor(difference_in_seconds / 3600);
	var hours_string = "";
	if (hours <= 9) {
	   hours_string = "0" + hours;
	}
	else {
	   hours_string = "" + hours;
	}
	var min =  Math.floor(difference_in_seconds  / 60) % 60;
	var min_string = "";
	if (min <= 9) {
	   min_string = "0" + min;
	}
	else {
	   min_string = "" + min;
	}
	var seconds = Math.floor(difference_in_seconds % 60);
	var seconds_string = "";
	if (seconds <= 9) {
	   seconds_string = "0" + seconds;
	}
	else {
	   seconds_string = "" + seconds;
	}
	
	this.current_time_running = hours_string  + ":" + min_string + ":" + seconds_string;

   }

     this.element.innerHTML = this.current_time_running
  }
  
}

